import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import update from 'react-addons-update';

import * as defaultStyles from '../../styles';
import Content from '../../content-manager/content';
import { host } from '../../utilities/requests';
import { request } from '../../containers/actions';
import { imageUrl } from '../../utilities/requests';
import { ServerDate } from '../../containers/ServerDate';


const MyComponent = ({ url, style }) => {

    return (
        <div className="MyComponent">
            <iframe id="pdfviewer" src={url} frameborder="0" style={style}></iframe>
        </div>
    );
};

//Radium(Folder);
export default class Folder extends React.PureComponent {
    static mimeMap = {
        html: 'text/html',
        swf: 'application/x-shockwave-flash',
        pdf: 'application/pdf',
    }
    static contextTypes = {
        store: PropTypes.object,
    }

    static propTypes = {
        data: PropTypes.object,
        height: PropTypes.number,
    }

    constructor(props) {
        super(props);
        this.state = {
            currentFile: null,
            currentTab: 'description',
            uploads: [],
            carouselScroll: 0,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.data || !this.props.data || nextProps.data.uuid !== this.props.data.uuid) {
            this.setState({ currentFile: null, currentTab: 'description', uploaded: [], carouselScroll: 0 });
        }
        if (nextProps.data && nextProps.data.files && nextProps.data.files.length === 1) {
            if (this.state.currentFile !== 0)
                this.setState({
                    currentFile: 0,
                    currentTab: nextProps.data.files[0].description || nextProps.type === 'download'
                        ? 'description'
                        : 'view',
                });
        }
    }

    moveTop() {
        const count = this.props.data.files.length + this.state.uploads.length;
        const itemHeight = this.refs.carouselContent.scrollHeight / count;
        if (this.state.carouselScroll - itemHeight <= 0) {
            this.setState({ carouselScroll: 0 });
            return false;
        }
        this.setState({
            carouselScroll: Math.max(
                this.state.carouselScroll - itemHeight,
                0,
            ),
        });
        return true;
    }

    moveBottom() {
        const count = this.props.data.files.length + this.state.uploads.length;
        const itemHeight = this.refs.carouselContent.scrollHeight / count;
        if (
            this.state.carouselScroll + itemHeight >=
            this.refs.carouselContent.scrollHeight -
            this.refs.carousel.clientHeight + 44
        ) {
            this.setState({
                carouselScroll: this.refs.carouselContent.scrollHeight - this.refs.carousel.clientHeight + 44,
            });
            return false;
        }
        this.setState({
            carouselScroll: Math.min(
                this.state.carouselScroll + itemHeight,
                this.refs.carouselContent.scrollHeight -
                this.refs.carousel.clientHeight + 44,
            ),
        });
        return true;
    }

    render() {

        if (!this.props.data)
            return null;
        return <div>
            <input
                type='file'
                multiple
                ref='fileSelector'
                style={{ display: 'none' }}
                onClick={() => {
                    this.refs.fileSelector.value = '';
                }}
                onChange={async () => {
                    for (let file of this.refs.fileSelector.files) {
                        const requestBody = window.toFormData({
                            name: file.name,
                            content: file,
                            folders: [this.props.data.uuid],
                        });
                        const token = this.context.store.getState().get('application').get('token');
                        const xmlHttp = new XMLHttpRequest();
                        const requestUUID = window.uuidv4();
                        xmlHttp.addEventListener('load', () => {
                            if (xmlHttp.status.toString()[0] === '2') {
                                const response = JSON.parse(xmlHttp.responseText);
                                this.props.addFile(this.props.data.uuid, response);
                            }
                        });
                        xmlHttp.upload.addEventListener('progress', event => {
                            const uploadIndex = _.findIndex(
                                this.state.uploads,
                                upload => upload.uuid === requestUUID,
                            );
                            const updatedUpload = update(
                                this.state.uploads[uploadIndex],
                                { progress: { $set: event.loaded / event.total } },
                            );
                            this.setState(update(this.state, {
                                uploads: {
                                    $splice: [[uploadIndex, 1, updatedUpload]],
                                }
                            }));
                        });
                        const uploadFinished = () => {
                            const uploadIndex = _.findIndex(
                                this.state.uploads,
                                upload => upload.uuid === requestUUID,
                            );
                            this.setState(update(this.state, {
                                uploads: {
                                    $splice: [[uploadIndex, 1]],
                                }
                            }));
                        };
                        xmlHttp.addEventListener('load', uploadFinished);
                        xmlHttp.addEventListener('error', uploadFinished);
                        xmlHttp.addEventListener('abort', uploadFinished);
                        const url = host + `/api/${this.props.type === 'video' ? 'video' : 'file'}/`;
                        xmlHttp.open('POST', url);
                        xmlHttp.setRequestHeader(
                            'authorization',
                            `${token.get('tokenType')} ${token.get('accessToken')}`,
                        );
                        xmlHttp.send(requestBody);
                        this.setState(update(this.state, {
                            uploads: {
                                $push: [{
                                    uuid: requestUUID,
                                    progress: 0,
                                    name: file.name,
                                    upload: true,
                                    request: xmlHttp,
                                }]
                            }
                        }));
                    }
                }}
            />
            <input
                type='file'
                multiple
                accept='image/*'
                ref='thumbnailSelector'
                style={{ display: 'none' }}
                onClick={() => {
                    this.refs.thumbnailSelector.value = '';
                }}
                onChange={async () => {
                    const file = this.refs.thumbnailSelector.files[0];
                    const requestBody = new FormData();
                    requestBody.append('thumbnail', file);
                    const response = await this.context.store.dispatch(request({
                        path: `/file/${this.refs.thumbnailSelector.dataset.uuid}/`,
                        body: requestBody,
                        method: 'PATCH',
                    }));
                    this.props.updateFile(this.props.data.uuid, response);
                }}
            />
            <div
                style={{
                    float: 'left',
                    width: '8.75em',
                    marginLeft: '.5em',
                    display: this.props.data.files.length === 1 && !this.props.editable ? 'none' : undefined,
                }}>

                {this.props.editable
                    ? <button
                        style={{ float: 'left', border: 'none', backgroundColor: 'inherit', marginBottom: '.5em' }}
                        onClick={() => {
                            this.refs.fileSelector.setAttribute('accept', (() => {
                                if (this.props.type === 'pdf')
                                    return 'application/pdf';
                                else if (this.props.type === 'video')
                                    return 'video/*';
                                else if (this.props.type === 'swf')
                                    return 'application/x-shockwave-flash';
                                else
                                    return '';
                            })());
                            this.refs.fileSelector.click();
                        }}>
                        <i className='fa-plus fa-2x'></i>
                    </button>
                    : null
                }
                <div
                    style={{
                        float: 'left',
                        clear: 'left',
                        width: '7.75em',
                        height: this.props.editable ? `calc(${this.props.height} - 2em)` : this.props.height,
                        position: 'relative',
                    }}
                    onWheel={event => {
                        const { deltaX, deltaY } = event;

                        let direction;
                        if (deltaX > 0 || deltaY > 0) {
                            direction = 1;
                        }
                        else if (deltaX < 0 || deltaY < 0) {
                            direction = -1;
                        }
                        else {
                            return;
                        }

                        if (
                            Date.now() - this.lastWheel < 150 &&
                            direction === this.lastWheelDirection
                        ) {
                            if (this.lastWheelResult)
                                event.preventDefault();
                            return;
                        }
                        this.lastWheel = Date.now();
                        this.lastWheelDirection = direction;
                        this.lastWheelResult = true;
                        if (direction === -1)
                            this.lastWheelResult = this.moveTop.bind(this)();
                        else if (direction === 1)
                            this.lastWheelResult = this.moveBottom.bind(this)();
                        if (this.lastWheelResult)
                            event.preventDefault();
                    }}>
                    <div
                        key='next'
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: '50%',
                            transform: 'translateX(-50%)',
                            height: '44px',
                            width: '100%',
                            backgroundImage: `url(${imageUrl(window.images['navigation-buttons'])})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: '-537px 5px',
                            boxShadow: '4px 0px 3px rgba(119,119,119,0.15), 4px -4px 3px ' +
                                'rgba(119,119,119,0.15), 4px 4px 3px rgba(119,119,119,0.15)',
                            cursor: 'pointer',
                            zIndex: 2,
                            backgroundColor: 'rgba(255, 255, 255, .4)',
                            ':hover': {
                                backgroundColor: 'rgba(255, 255, 255, .7)',
                            },
                        }}
                        onClick={event => {
                            event.stopPropagation();
                            this.moveTop.bind(this)();
                        }}>

                    </div>
                    <div
                        key='previous'
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            left: '50%',
                            transform: 'translateX(-50%) rotateY(180deg)',
                            height: '44px',
                            width: '100%',
                            backgroundImage: `url(${imageUrl(window.images['navigation-buttons'])})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: '-207px -5px',
                            boxShadow: '-4px 0px 3px rgba(119,119,119,0.15), -4px -4px 3px ' +
                                'rgba(119,119,119,0.15), -4px 4px 3px rgba(119,119,119,0.15)',
                            cursor: 'pointer',
                            zIndex: 2,
                            backgroundColor: 'rgba(255, 255, 255, .4)',
                            ':hover': {
                                backgroundColor: 'rgba(255, 255, 255, .7)',
                            },
                        }}
                        onClick={event => {
                            event.stopPropagation();
                            this.moveBottom.bind(this)();
                        }}>
                    </div>
                    <div
                        ref='carousel'
                        style={{
                            height: '100%',
                            overflow: 'hidden',
                            marginRight: '-10em',
                            paddingRight: '10em',
                        }}>
                        <div
                            ref='carouselContent'
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                transform: `translateY(${-this.state.carouselScroll}px)`,
                                transition: 'transform 1s',
                                position: 'relative',
                                width: '100%',
                                zIndex: '1',
                            }}>
                            {_.map(_.concat(this.props.data.files, this.state.uploads), (file, index) => <div
                                key={file.uuid}
                                style={{ position: 'relative' }}>
                                <div
                                    key={file.uuid}
                                    style={{
                                        width: '7.75em',
                                        flexBasis: '7.75em',
                                        flexShrink: '0',
                                        boxSizing: 'border-box',
                                        padding: '.5em',
                                        cursor: 'pointer',
                                        ':hover': {
                                            width: '7.75em',
                                        },
                                    }}
                                    onClick={async () => {
                                        if (file.upload)
                                            return;
                                        this.setState({
                                            currentFile: index,
                                            currentTab:
                                                this.props.data.files[index]?.description || this.props.type === 'download'
                                                    ? 'description'
                                                    : 'view',
                                        });
                                    }}>
                                    <img
                                        style={{
                                            width: '6.75em',
                                            height: '4.5em',
                                            objectFit: 'cover',
                                            backgroundColor: '#cacaca',
                                            boxShadow: '0 6px 6px 0 rgba(119,119,119,0.75)',
                                            borderRadius: '6px',
                                            marginBottom: '.4em',
                                        }}
                                        src={imageUrl(file.uuid, {
                                            width: 96,
                                            height: 72,
                                            type: 'cover',
                                        }) + `?version=${file.thumbnail_version}`}
                                        onError={(e) => {
                                            if (!e.target.value)
                                                e.target.src = 'https://static.vecteezy.com/system/resources/previews/004/141/669/non_2x/no-photo-or-blank-image-icon-loading-images-or-missing-image-mark-image-not-available-or-image-coming-soon-sign-simple-nature-silhouette-in-frame-isolated-illustration-vector.jpg'

                                            if (!file.upload && (file.retry || 0) <= 3) {

                                                setTimeout(() => {

                                                    if (this.props.data.files.length > index &&
                                                        file.uuid === this.props.data.files[index].uuid)
                                                        this.props.updateFile(
                                                            this.props.data.uuid,
                                                            {
                                                                ...file,
                                                                thumbnail_version: ServerDate().getTime(),
                                                                retry: (file.retry || 0) + 1,
                                                            },
                                                        );
                                                }, 1500);
                                            }
                                        }}
                                    />
                                    <div style={{ whiteSpace: 'nowrap' }}>
                                        {file.upload
                                            ? <button
                                                key={'cancel-' + file.uuid}
                                                style={{ ...defaultStyles.button, minWidth: undefined }}
                                                onClick={async event => {
                                                    event.stopPropagation();
                                                    if (!window.confirm(window.gettext(
                                                        'Are you sure you wanna cancel this upload?',
                                                    )))
                                                        return;
                                                    file.request.abort();
                                                }}>
                                                <i className='fa-ban'></i>
                                            </button>
                                            : null
                                        }
                                        {this.props.editable && !file.upload
                                            ? <span>
                                                <button
                                                    key={'delete-' + file.uuid}
                                                    style={{ ...defaultStyles.button, minWidth: undefined }}
                                                    onClick={async event => {
                                                        event.stopPropagation();
                                                        if (!window.confirm(window.gettext(
                                                            'Are you sure you wanna delete this file?',
                                                        )))
                                                            return;
                                                        await this.context.store.dispatch(request({
                                                            path: `/file/${file.uuid}/`,
                                                            method: 'DELETE',
                                                        }));
                                                        this.props.removeFile(this.props.data.uuid, file.uuid);
                                                    }}>
                                                    <i className='fa-times'></i>
                                                </button>
                                                <button
                                                    key={'note-' + file.uuid}
                                                    style={{ ...defaultStyles.button, minWidth: undefined }}
                                                    onClick={async event => {
                                                        event.stopPropagation();
                                                        const note = prompt(
                                                            window.gettext('Enter file note') + ':',
                                                            file.note || '',
                                                        );
                                                        if (note === null)
                                                            return;
                                                        const response = await this.context.store.dispatch(request({
                                                            path: `/file/${file.uuid}/`,
                                                            body: { note },
                                                            method: 'PATCH',
                                                        }));
                                                        this.props.updateFile(this.props.data.uuid, response);
                                                    }}>
                                                    <i className='fa-pencil'></i>
                                                </button>
                                                <button
                                                    key={'download-' + file.uuid}
                                                    style={{ ...defaultStyles.button, minWidth: undefined }}
                                                    onClick={async event => {
                                                        event.stopPropagation();
                                                        const response = await this.context.store.dispatch(request({
                                                            path: `/file/${file.uuid}/`,
                                                            body: { download: !file.download },
                                                            method: 'PATCH',
                                                        }));
                                                        this.props.updateFile(this.props.data.uuid, response);
                                                    }}>
                                                    <i className={`fa fa-${file.download ? 'download' : 'ban'}`}></i>
                                                </button>
                                                <button
                                                    key={'thumbnail-' + file.uuid}
                                                    style={{ ...defaultStyles.button, minWidth: undefined }}
                                                    onClick={() => {
                                                        this.refs.thumbnailSelector.dataset.uuid = file.uuid;
                                                        this.refs.thumbnailSelector.click();
                                                    }}>
                                                    <i className='fa-picture-o'></i>
                                                </button>
                                            </span>
                                            : null
                                        }
                                        <div
                                            style={{
                                                position: 'relative',
                                                overflow: 'visible',
                                                float: 'right',
                                                width: '100%',
                                            }}>
                                            {file.upload
                                                ? <div
                                                    style={{
                                                        backgroundColor: '#70b0d9',
                                                        width: `${file.progress * 100}%`,
                                                        position: 'absolute',
                                                        right: '0',
                                                        height: '100%',
                                                    }}>
                                                </div>
                                                : null
                                            }
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    width: '100%',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    fontSize: '.8em',
                                                    cursor: this.props.editable ? 'text' : undefined,
                                                }}
                                                onClick={async (event) => {
                                                    if (!this.props.editable)
                                                        return;
                                                    event.stopPropagation();
                                                    const name = prompt(
                                                        window.gettext('Enter file name') + ':',
                                                        file.name || '',
                                                    );
                                                    if (name === null)
                                                        return;
                                                    const response = await this.context.store.dispatch(request({
                                                        path: `/file/${file.uuid}/`,
                                                        body: { name },
                                                        method: 'PATCH',
                                                    }));
                                                    this.props.updateFile(this.props.data.uuid, response);
                                                }}>
                                                {file.name || '\u00A0'}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {file.note && Radium.getState(this.state, file.uuid, ':hover')
                                    ? <div
                                        style={{
                                            pointerEvents: 'none',
                                            position: 'absolute',
                                            top: '1.5em',
                                            left: '1.5em',
                                            width: '17em',
                                            backgroundColor: '#cacaca',
                                            border: '.0625em solid black',
                                            zIndex: '3',
                                            fontSize: '.7em',
                                            padding: '.5em',
                                        }}>
                                        {file.note}
                                    </div>
                                    : null
                                }
                            </div>)}
                        </div>
                    </div>
                </div>
            </div>
            {this.state.currentFile !== null
                ? <div
                    style={{
                        marginTop: '.5em',
                        position: 'relative',
                        float: 'right',
                        width: this.props.data.files.length === 1 && !this.props.editable
                            ? '100%'
                            : 'calc(100% - 9.25em)',
                    }}>
                    {this.state.currentTab === 'view' &&
                        (this.props.editable || this.props.data?.files[this.state.currentFile]?.description)
                        ? <button
                            key='description'
                            style={{
                                position: 'absolute',
                                left: '1.5em',
                                top: '3.5em',
                                opacity: '.5',
                                zIndex: '1',
                                padding: '.5em',
                                cursor: 'pointer',
                                borderRadius: '.25em',
                                backgroundColor: 'rgba(255, 255, 255, .6)',
                                border: 'none',
                                ':hover': {
                                    backgroundColor: 'rgba(255, 255, 255, .8)',
                                    opacity: '1',
                                },
                            }}
                            onClick={() => this.setState({ currentTab: 'description' })}>
                            <i className={'fa-align-right fa-lg'}></i>
                            &nbsp;
                            {window.gettext('Description')}
                        </button>
                        : null
                    }
                    {this.state.currentTab === 'description' &&
                        (
                            this.props.editable ||
                            this.props.data.files[this.state.currentFile]?.description ||
                            this.props.type === 'download'
                        )
                        ? <div
                            key='preview'
                            style={{
                                position: 'absolute',
                                left: '1.5em',
                                top: '3.5em',
                                opacity: '.5',
                                zIndex: '1',
                                padding: '.5em',
                                cursor: 'pointer',
                                borderRadius: '.25em',
                                backgroundColor: 'rgba(180, 180, 180, .6)',
                                ':hover': {
                                    backgroundColor: 'rgba(180, 180, 180, .8)',
                                    opacity: '1',
                                },
                            }}
                            onClick={() => {
                                if (this.props.type === 'download')
                                    window.location =
                                        host + `/file/${this.props.data.uuid}/${this.props.data.files[this.state.currentFile].uuid}`;
                                else
                                    this.setState({ currentTab: 'view' });
                            }}>
                            <i className={`fa fa-${this.props.type === 'video'
                                ? 'play'
                                : this.props.type === 'download'
                                    ? 'download'
                                    : 'eye'} fa-lg`}></i>
                            &nbsp;
                            {this.props.type === 'video'
                                ? window.gettext('Play')
                                : this.props.type === 'download'
                                    ? window.gettext('Download')
                                    : window.gettext('View')}
                        </div>
                        : null
                    }
                    {this.state.currentTab === 'description'
                        ? <div
                            style={{
                                width: '100%',
                                height: this.props.height,
                                marginTop: '.5em',
                                overflowY: 'auto',
                                overflowX: 'hidden',
                            }}>
                            <Content
                                style={{
                                    display: 'block',
                                    backgroundColor: 'white',
                                }}
                                readonly={!this.props.editable}
                                inline={false}
                                preview={false}
                                content={this.props.data.files[this.state.currentFile]?.description}
                                actions={[{
                                    label: window.gettext('Save'),
                                    action: async () => {
                                        const response = await this.context.store.dispatch(request({
                                            path: `/file/${this.props.data.files[this.state.currentFile].uuid}/`,
                                            body: { description: this.state?.description },
                                            method: 'PATCH',
                                        }));
                                        this.props.updateFile(this.props.data.uuid, response);
                                    },
                                }]}
                                onChange={content => {
                                    this.setState({ description: content });
                                }}
                            />
                        </div>
                        : this.props.type === 'video'
                            ? <div
                                style={{
                                    position: 'relative',
                                    display: 'inline-block',
                                    float: 'right',
                                    width: '100%',
                                }}>
                                <video
                                    style={{
                                        backgroundColor: 'black',
                                        width: '100%',
                                        height: this.props.height,
                                    }}
                                    autoPlay
                                    controls
                                    controlsList='nodownload'
                                    src={`/file/${this.props.data.uuid}/${this.props.data.files[this.state.currentFile].uuid}`}
                                    onLoadStart={() => this.setState({ loadingVideo: true })}
                                    onCanPlay={() => this.setState({ loadingVideo: false })}
                                    onContextMenu={event => event.preventDefault()}
                                />
                                {this.state.loadingVideo
                                    ? <div
                                        style={{
                                            position: 'absolute',
                                            top: '0',
                                            width: '100%',
                                            height: '100%',
                                            background: 'rgba(255, 255, 255, .2)',
                                        }}>
                                        <i
                                            className='fa-spin fa-spinner fa-2x'
                                            style={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)',
                                            }}>
                                        </i>
                                    </div>
                                    : null
                                }
                            </div>
                            : this.props.type === 'pdf'
                                ? <MyComponent url={host + `/file/${this.props.data.uuid}/${this.props.data.files[this.state.currentFile].uuid}` +
                                    '?inline=1&type=' + encodeURIComponent('application/pdf')}
                                    style={{
                                        float: 'right',
                                        width: '100%',
                                        height: this.props.height,
                                    }}
                                ></MyComponent>
                                // <object
                                //     style={{
                                //         float: 'right',
                                //         width: '100%',
                                //         height: this.props.height,
                                //     }}
                                //     data={host + `/file/${this.props.data.uuid}/${this.props.data.files[this.state.currentFile].uuid}` +
                                // '?inline=1&type=' + encodeURIComponent('application/pdf')}
                                //     type='application/pdf'>
                                //     <embed
                                //         style={{
                                //             width: '100%',
                                //             height: this.props.height,
                                //         }}
                                //         src={host + `/file/${this.props.data.uuid}/${this.props.data.files[this.state.currentFile].uuid}` +
                                //     '?inline=1&type=' + encodeURIComponent('application/pdf')}
                                //         type='application/pdf'
                                //     />
                                // </object>
                                : this.props.type === 'swf'
                                    ? <object
                                        style={{
                                            float: 'right',
                                            width: '100%',
                                            height: this.props.height,
                                        }}
                                        data={`/file/${this.props.data.uuid}/${this.props.data.files[this.state.currentFile].uuid}` +
                                            '?inline=1&type=' + encodeURIComponent(
                                                Folder.mimeMap[_.last(
                                                    this.props.data.files[this.state.currentFile].name.split('.'),
                                                ).toLowerCase()],
                                            )
                                        }
                                        type={Folder.mimeMap[_.last(
                                            this.props.data.files[this.state.currentFile].name.split('.'),
                                        ).toLowerCase()]}>
                                        <embed
                                            style={{
                                                width: '100%',
                                                height: this.props.height,
                                            }}
                                            src={`/file/${this.props.data.uuid}/${this.props.data.files[this.state.currentFile].uuid}` +
                                                '?inline=1&type=' + encodeURIComponent(
                                                    Folder.mimeMap[_.last(
                                                        this.props.data.files[this.state.currentFile].name.split('.'),
                                                    ).toLowerCase()],
                                                )}
                                            type={Folder.mimeMap[_.last(
                                                this.props.data.files[this.state.currentFile].name.split('.'),
                                            ).toLowerCase()]}
                                        />
                                    </object>
                                    : null
                    }
                </div>
                : null
            }
        </div>;
    }
}
